var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    [
      _c("slide-in-overlay", {
        staticClass: "o-contactform",
        attrs: { "is-open": _vm.isOpen, "max-width": "721px" },
        on: { close: _vm.closeForm },
        scopedSlots: _vm._u(
          [
            {
              key: "body",
              fn: function() {
                return [
                  _c("h1", [_vm._v(_vm._s(_vm.title))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "o-contactform__trumpet" }, [
                    _vm._v("\n        " + _vm._s(_vm.trumpet) + "\n      ")
                  ]),
                  _vm._v(" "),
                  !_vm.success ? _vm._t("urgent") : _vm._e(),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(_vm.translations["Subject"]))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "o-contactform__subjects" }, [
                    _c("div", { staticClass: "o-contactform__subject" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.subject,
                            expression: "subject"
                          }
                        ],
                        attrs: {
                          id: "subject_support",
                          name: "subject",
                          type: "radio",
                          value: "Support & Information"
                        },
                        domProps: {
                          checked: _vm._q(_vm.subject, "Support & Information")
                        },
                        on: {
                          change: function($event) {
                            _vm.subject = "Support & Information"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "subject_support" } },
                        [
                          _c("subject-support"),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.translations["Support & Information"]
                              ) +
                              "\n          "
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "o-contactform__subject" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.subject,
                            expression: "subject"
                          }
                        ],
                        attrs: {
                          id: "subject_development",
                          name: "subject",
                          type: "radio",
                          value: "Development"
                        },
                        domProps: {
                          checked: _vm._q(_vm.subject, "Development")
                        },
                        on: {
                          change: function($event) {
                            _vm.subject = "Development"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "subject_development" } },
                        [
                          _c("subject-development"),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.translations["Development"]) +
                              "\n          "
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "o-contactform__subject" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.subject,
                            expression: "subject"
                          }
                        ],
                        attrs: {
                          id: "subject_training",
                          name: "subject",
                          type: "radio",
                          value: "Training & Service"
                        },
                        domProps: {
                          checked: _vm._q(_vm.subject, "Training & Service")
                        },
                        on: {
                          change: function($event) {
                            _vm.subject = "Training & Service"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "subject_training" } },
                        [
                          _c("subject-training"),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.translations["Training & service"]) +
                              "\n          "
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h3", [
                    _vm._v(_vm._s(_vm.translations["Contact information"]))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: "action",
                      value: "contact-form/send"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "o-fieldsgrid" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "o-input o-fieldsgrid__field o-fieldsgrid__field--half"
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fromName,
                              expression: "fromName"
                            }
                          ],
                          staticClass: "w-full validate input",
                          class: { valid: _vm.fromName },
                          attrs: {
                            type: "text",
                            id: "fromName",
                            name: "fromName",
                            required: "required"
                          },
                          domProps: { value: _vm.fromName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.fromName = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "fromName" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.translations["Name of contact"]) +
                              "*\n          "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "o-input o-fieldsgrid__field o-fieldsgrid__field--half"
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.company,
                              expression: "company"
                            }
                          ],
                          staticClass: "w-full validate input",
                          class: { valid: _vm.company },
                          attrs: {
                            type: "text",
                            id: "contactCompany",
                            name: "message['company']",
                            required: "required"
                          },
                          domProps: { value: _vm.company },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.company = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "contactCompany" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.translations["Company"]) + "* "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "o-input o-fieldsgrid__field o-fieldsgrid__field--half"
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fromEmail,
                              expression: "fromEmail"
                            }
                          ],
                          staticClass: "w-full validate input",
                          class: { valid: _vm.fromEmail },
                          attrs: {
                            type: "text",
                            id: "contactEmail",
                            name: "fromEmail",
                            required: "required"
                          },
                          domProps: { value: _vm.fromEmail },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.fromEmail = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "contactEmail" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.translations["E-mail"]) + "* "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "o-input o-fieldsgrid__field o-fieldsgrid__field--half"
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone"
                            }
                          ],
                          staticClass: "w-full validate input",
                          class: { valid: _vm.phone },
                          attrs: {
                            type: "text",
                            id: "contactphone",
                            name: "phone",
                            required: "required"
                          },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phone = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "contactphone" } }, [
                          _vm._v(" " + _vm._s(_vm.translations["Phone"]) + "* ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "o-input o-fieldsgrid__field o-fieldsgrid__field--full"
                      },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.message,
                              expression: "message"
                            }
                          ],
                          class: { valid: _vm.message },
                          attrs: {
                            rows: "10",
                            cols: "40",
                            id: "message",
                            name: "message[comment]"
                          },
                          domProps: { value: _vm.message },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.message = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "message" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.translations["Comment"]) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        position: "fixed",
                        left: "-100%",
                        top: "-100%"
                      },
                      attrs: { tabindex: "-1", "aria-hidden": "true" }
                    },
                    [
                      _c("label", {
                        attrs: {
                          for: "50d642e8-add6-4cd0-aa23-0341da07a60c",
                          "aria-hidden": "true",
                          tabindex: "-1"
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form_company,
                            expression: "form_company"
                          }
                        ],
                        attrs: {
                          type: "text",
                          name: "form_company",
                          value: "",
                          id: "50d642e8-add6-4cd0-aa23-0341da07a60c",
                          tabindex: "-1",
                          "aria-hidden": "true"
                        },
                        domProps: { value: _vm.form_company },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.form_company = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "o-btn o-btn--filled",
                      on: {
                        click: function($event) {
                          return _vm.submitForm()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.translations["Send request"]) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "o-contactform__term" },
                    [
                      _c("clock-icon"),
                      _vm._v(
                        _vm._s(
                          _vm.translations[
                            "We strive to respond to your request within 24 hours"
                          ]
                        ) + "\n      "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.isSubmitting
                      ? _c(
                          "div",
                          { staticClass: "o-contactform__loader" },
                          [
                            !_vm.success ? _vm._t("loader") : _vm._e(),
                            _vm._v(" "),
                            _vm.success ? _vm._t("success") : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      !_vm.isOpen
        ? _c("sticky-contact", {
            attrs: {
              title: _vm.title,
              text: _vm.translations["Send us your request"]
            },
            on: { "please-open": _vm.slideOut }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }